import axios from "axios";
import { FETCH_VEHICLE_MODELS_FAILURE, FETCH_VEHICLE_MODELS_REQUEST, FETCH_VEHICLE_MODELS_SUCCESS, FETCH_VEHICLE_MODELS_SUCCESS_2, FETCH_VEHICLE_MODEL_FAILURE, FETCH_VEHICLE_MODEL_REQUEST, FETCH_VEHICLE_MODEL_SUCCESS,  } from "../../app/actions/actions";
import { ROUTES } from "../../config/routingUrl";
import { dureeDeVie, setWithExpiration } from "../../utils/storage/localvalueFuction";
import { localStorageData, localStorageKeys } from "../../utils/storage/localvalue";
import { baseurl } from "../../utils/url/baseurl";
import { saveDataToFile } from "../DataLocal";



// Create VehicleModel
export const VehicleModelCreate = (
    data,
    toast) => {
    return async (dispatch) => {
        dispatch({ type: FETCH_VEHICLE_MODEL_REQUEST });
        await axios
            .post(
                `${baseurl.url}/api/v1/vehiclemodels/`,
                data,
                {
                    headers:
                    {
                        'Content-Type': 'application/json',
                        'Authorization': `${baseurl.TypeToken} ${baseurl.token}`
                    }
                }
            )
            .then((response) => {
                toast.success("nouvel type de véhicule ajouté");
                dispatch({ type: FETCH_VEHICLE_MODEL_SUCCESS });
            })
            .catch((error) => {
                toast.error("type de véhicule non ajouté")
                dispatch({ type: FETCH_VEHICLE_MODEL_FAILURE, payload: error.message });
            });
    };
}



// update insurance 
export const VehicleModelUpdateById = (idVehicleModel, data, toast) => {
    return async (dispatch) => {
        dispatch({ type: FETCH_VEHICLE_MODEL_REQUEST });
        await axios
            .put(`${baseurl.url}/api/v1/vehiclemodels/update/${idVehicleModel}`, data, {
                headers:
                {
                    'Content-Type': 'application/json',
                    'Authorization': `${baseurl.TypeToken} ${baseurl.token}`
                }
            })
            .then((response) => {
                dispatch({ type: FETCH_VEHICLE_MODEL_SUCCESS });
                dispatch(fetchVehicleModelById(idVehicleModel));
                toast.success("Type de véhicle mis à jour");
            })
            .catch((error) => {
                dispatch({ type: FETCH_VEHICLE_MODEL_FAILURE, payload: error.message });
                toast.error("Véhicule non mis à jour")
            });
    };
}





// All insurance of plateforme
export function fetchVehicleModelsAll(filterBy) {
    return async (dispatch) => {
        const params = new URLSearchParams();
        if (filterBy) params.append("filterBy", filterBy);
        dispatch({ type: FETCH_VEHICLE_MODELS_REQUEST });
        await axios.get(`${baseurl.url}/api/v1/vehiclemodels/get_vehiclemodels?${params.toString()}`, {
            headers: {
                'Content-Type': 'application/json',
                'Authorization': `${baseurl.TypeToken} ${baseurl.token}`
            }
        }).then((response) => {
            //console.log(response.data.data);
            dispatch({ type: FETCH_VEHICLE_MODELS_SUCCESS, payload: response.data.data });
            dispatch({ type: FETCH_VEHICLE_MODELS_SUCCESS_2, payload: response.data.data });
            saveDataToFile(response.data.data, localStorageData.VehicleModels);
        })
            .catch((error) => {
                //console.log(error);
                dispatch({ type: FETCH_VEHICLE_MODELS_FAILURE, payload: error.message });
            });
    }
}


// get insurance by id 
export function fetchVehicleModelById(idVehicleModel) {
    return async (dispatch) => {
        dispatch({ type: FETCH_VEHICLE_MODEL_REQUEST });
        await axios.get(`${baseurl.url}/api/v1/vehiclemodels/get_vehiclemodel/${idVehicleModel}`, {
            headers: {
                'Content-Type': 'application/json',
                'Authorization': `${baseurl.TypeToken} ${baseurl.token}`
            }
        }).then((response) => {
            //console.log(response.data.data);
            dispatch({ type: FETCH_VEHICLE_MODEL_SUCCESS, payload: response.data.data });
        })
            .catch((error) => {
                dispatch({ type: FETCH_VEHICLE_MODEL_FAILURE, payload: error.message })
                //console.log(error);
            });
    }
}

